import { React ,useState, useRef} from 'react';
import { isMobile } from 'react-device-detect';
import Header from './HeaderMob';
import { useNavigate } from "react-router-dom";
import Register from './registerMob';

function RegisterpageMob() {

    const openInSameTab = url => {
        window.open(url, '_self', 'noopener,noreferrer');
    };
    
    const navigate = useNavigate();


    function afterLogin() { 
        setTimeout(function () {
            navigate(-1);
        }, 1000);
        
    }
    return (
        <div className="buyMain flex justify-center items-center w-full h-dvh text-black">
        <div className={"mouse2 text-black w-full absolute bottom-0 flex justify-center align-middle"} onClick={() => navigate("/")} >
    [ BACK TO GALAXY ]
</div> 
            <Register callback={afterLogin} alreadyToLogin={true}/>
            <Header bg={true} destination="/" from="about" />
        </div>
        )
}

export default RegisterpageMob

